import CommonAPI from '@/services-ts/Common'
import CompanyAPI from '@/services-ts/Company'
import MessageAPI from '@/services-ts/Message'
import PointAPI from '@/services-ts/Point'
import PostAPI from '@/services-ts/Post'
import ReportAPI from '@/services-ts/Report'
import UserAPI from '@/services-ts/User'

import { apiMaker } from './apiConfig'

export const userAPI = UserAPI(apiMaker('apiUser'))
export const commonAPI = CommonAPI(apiMaker('apiCommon'))
export const companyAPI = CompanyAPI(apiMaker('apiCompany'))
export const postAPI = PostAPI(apiMaker('apiPost'))
export const pointAPI = PointAPI(apiMaker('apiPoint'))
export const messageAPI = MessageAPI(apiMaker('apiMessage'))
export const reportAPI = ReportAPI(apiMaker('apiReport'))
